import { useTranslation } from "react-i18next";

import { Panel } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";

import { StackOrShelf } from "@/App/components/StackOrShelf";
import { ThemedButton } from "@/App/components";
import { DMRDrug } from "@/App/api/drug";

const TRANSLATION_PATH = "DIRECT_MEMBER_REIMBURSEMENT.prescriptionVaccineEquipmentDetails";

interface PrescriptionVaccineEquipmentCard {
  readonly dmrDrug: DMRDrug;
  readonly isSelected?: boolean;
  readonly setSelectedPrescriptionVaccineEquipment: React.Dispatch<React.SetStateAction<DMRDrug | null>>
}

export const DirectMemberReimbursementPrescriptionVaccineEquipmentCard = (
  { dmrDrug, isSelected = false, setSelectedPrescriptionVaccineEquipment }: PrescriptionVaccineEquipmentCard,
) => {
  const { t: translate } = useTranslation();

  const onClickPharmacyCard = () => {
      if (isSelected) {
        setSelectedPrescriptionVaccineEquipment(null);
      } else {
        setSelectedPrescriptionVaccineEquipment(dmrDrug);
      }
    };

  return (
    <Panel appearance="primary">
      <StackOrShelf spacing="medium">
        <Stack alignment="left" spacing="small">
          <Shelf alignment="top">
            <Stack alignment="left" spacing="none">
              <Body style={{ color: "#60646D" }}><Semibold>{translate(`${TRANSLATION_PATH}.ndcOrUpc`)}: {dmrDrug.ndc}</Semibold></Body>
              <Body><Semibold>{dmrDrug?.drug_name}</Semibold></Body>
            </Stack>
          </Shelf>
          <Stack.Spacer />
          <Shelf alignment="top">
            <Stack alignment="left" spacing="none">
              {dmrDrug?.dosage && <Body>{dmrDrug?.dosage}</Body>}
              {dmrDrug?.dosage_form && <Body>{dmrDrug?.dosage_form}</Body>}
            </Stack>
          </Shelf>
        </Stack>
        <Shelf.Spacer />
        <ThemedButton onClick={onClickPharmacyCard} appearance="secondary">
        {isSelected && translate(`${TRANSLATION_PATH}.change`)}
        {!isSelected && translate(`${TRANSLATION_PATH}.select`)}
        </ThemedButton>
      </StackOrShelf>
    </Panel>
  );
};
